export const STICKY_OFFSET = 24
export const PANEL_WIDTH = 240

export function getPanelGutterOffset(formRight: number, boundaryRight: number): number {
  const requiredSpace = PANEL_WIDTH + STICKY_OFFSET
  return boundaryRight - formRight >= requiredSpace ? requiredSpace : 0
}
